import { Spinner } from "react-bootstrap";

export const QuerySpinner = () => {
  return (
    <div
      className="row p-2"
      style={{ fontSize: "20px !important", justifyContent: "center" }}
    >
      <Spinner />
    </div>
  );
};
